module.exports = __webpack_public_path__ + "b5340f628e0767f44b6758e4f25b0c2b.svg";